import { useEffect, useRef } from "react";
import { Chart } from "chart.js/auto";
import { defaultColors } from "../../datas/colors";

export default function BarChart() {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");
    chartInstance.current = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Menor que 0", "0", "1", "2", "3 a 6", "7"],
        datasets: [
          {
            label: "",
            data: [33, 360, 737, 338, 61, 1],
            backgroundColor: defaultColors,
            borderRadius: 12,
            barThickness: 26,
          },
        ],
      },
      options: {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 20,
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: true,
            backgroundColor: "#ffffff", // Fundo branco
            titleColor: "#333333", // Cor do título mais escura para melhor leitura
            titleFont: { weight: "bold", size: 14 }, // Fonte do título mais destacada
            bodyColor: "#444444", // Cor do corpo (habilidade + descrição)
            bodyFont: { size: 13 }, // Tamanho da fonte do corpo
            footerColor: "#1565C0", // Azul mais sofisticado para o footer
            footerFont: { weight: "bold", size: 12 }, // Fonte do footer destacada
            borderColor: "#DDDDDD", // Borda cinza clara
            borderWidth: 1,
            cornerRadius: 10, // Cantos mais arredondados
            padding: 12, // Mais espaço para melhor visualização
            displayColors: false,
            callbacks: {
              label: (context) => `${context.raw} questões com o nível`,
            },
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: true,
              drawBorder: false,
              color: "#e5e7eb",
            },
            ticks: {
              font: {
                size: 13,
              },
              color: "#374151",
            },
          },
          y: {
            grid: {
              display: false,
            },
            ticks: {
              font: {
                size: 14,
                weight: "bold",
              },
              color: "#1f2937",
              padding: 5,
            },
          },
        },
      },
    });

    return () => chartInstance.current.destroy();
  }, []);

  return (
    <div className="p-6 mx-4 bg-white shadow-lg rounded-xl border border-gray-200 w-full md:w-1/2">
      <h2 className="text-2xl font-bold text-gray-900">
        Nível das Questões de Humanas
      </h2>
      <p className="text-gray-500 text-sm">2009 - 2023</p>
      <div className="relative w-full h-80 mt-4">
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
}
